//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'LeftMenu',
  props: {
    miniVariant: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      clipped: true,
      drawer: false,
    }
  },
  computed: {
    minimize: {
      get() {
        return this.miniVariant
      },
      set(value) {
        this.$emit('variantChanged', value)
      },
    },
    menuItems() {
      return this.$auth.user.menuItems
    },
  },
}
